import { render, staticRenderFns } from "./wechat_drafts.vue?vue&type=template&id=3948cf52&scoped=true"
import script from "./wechat_drafts.vue?vue&type=script&lang=js"
export * from "./wechat_drafts.vue?vue&type=script&lang=js"
import style0 from "./wechat_drafts.vue?vue&type=style&index=0&id=3948cf52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948cf52",
  null
  
)

export default component.exports